<template>
  <div class="editDict">
    <!--新增-->
    <el-dialog
      :title="$t('dict.editTitle')"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form
        label-width="auto"
        :rules="rules"
        :model="addList"
        ref="addList"
        :label-position="'right'"
      >
        <el-form-item :label="$t('dict.dictName')" prop="dictName">
          <el-input
            v-model="addList.dictName"
            clearable
            :placeholder="$t('dict.dictNamePlaceholder')"
          ></el-input>
        </el-form-item>
        <el-tooltip class="item" effect="dark" :content="$t('dict.dictNameTips')" placement="right">
          <el-form-item :label="$t('dict.dictType')" prop="dictType">
            <el-input
              v-model="addList.dictType"
              clearable
              :placeholder="$t('dict.dictTypePlaceholder')"
            ></el-input>
          </el-form-item>
        </el-tooltip>
        <el-form-item :label="$t('dict.remark')" prop="remark">
          <el-input
            type="textarea"
            v-model="addList.remark"
            :rows="2"
            clearable
            :placeholder="$t('dict.remarkPlaceholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('dict.sortNo')" prop="sortNo">
          <el-input-number
            v-model="addList.sortNo"
            controls-position="right"
            :min="0"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogEdit = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '../../../api/systemManage/dict.js';
  export default {
    name: 'editDict',
    data() {
      return {
        dialogEdit: false,
        loading: false,
        addList: {
          dictCode: '',
          dictName: '',
          dictType: '',
          remark: '',
          sortNo: '',
        },
      };
    },
    computed: {
      rules() {
        // 校验特殊字符
        var specialValidate = (_, value, callback) => {
          // var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          var regEn = /[`!@#$%^&*()+<>?:"{},.\/;'[\]]/im,
            regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
          if (regEn.test(value) || regCn.test(value)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          dictCode: [
            {
              required: true,
              message: this.$t('dict.dictCodeNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          dictName: [
            {
              required: true,
              message: this.$t('dict.dictNameNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          dictType: [
            {
              required: true,
              message: this.$t('dict.dictTypeNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            // { validator: specialValidate, trigger: ["blur", "change"] }
          ],
          remark: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            // { validator: specialValidate, trigger: ["blur", "change"] }
          ],
          sortNo: [
            {
              required: true,
              message: this.$t('dict.sortNoNotEmpty'),
              trigger: 'blur',
            },
          ],
        };
      },
    },
    methods: {
      openDialog(flag, value) {
        if (this.$refs['addList']) {
          this.$refs['addList'].resetFields();
        }
        this.loading = false;
        this.dialogEdit = flag;
        this.getDetail(value);
      },
      // 获取详情
      getDetail(id) {
        this.$axios.post(API.GET_DICT_API, { id: id }).then((res) => {
          if (0 == res.data.code) {
            this.addList = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //保存
      addSure() {
        this.$refs.addList.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            this.$axios.post(API.UPDATE_DICT_API, this.addList).then((res) => {
              this.loading = false;
              if (0 != res.data.code) {
                this.$alert(res.data.msg);
              } else {
                this.dialogEdit = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
